export const DESCOPE_PREFIX = 'descope';
export const CSS_SELECTOR_SPECIFIER_MULTIPLY = 5;
export const BASE_THEME_SECTION = 'host';
export const PORTAL_THEME_PREFIX = '@';
